import Vue from 'vue'

import ApiRequest from '@/services/ApiRequests/ApiRequest'
import IssuingApi from '@/services/Api/IssuingApi'

const cardOrderTotalCountApiRequest = new ApiRequest(IssuingApi.fetchCardOrderTotalCount)

const state = () => ({
  totalCount: 0
})

const getters = {
  cardOrderTotalCount: (state) => {
    return state.totalCount
  }
}

const actions = {
  loadCardOrderTotalCount ({ commit }) {
    return cardOrderTotalCountApiRequest.execute()
      .then(({ count }) => commit('setTotalCount', count))
      .catch(() => {})
  },
  cancelLoadCardOrderTotalCount () {
    cardOrderTotalCountApiRequest.cancel()
  }
}

const mutations = {
  setTotalCount (state, totalCount) {
    Vue.set(state, 'totalCount', totalCount)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
